 <!--卫星云图-->
<template>
    <div class="wxyt">
        <div  class="wxtPlay">
            <i class="el-icon-caret-left" title="上一张"  @click="pre"></i>
            <img src="@/assets/images/play.png" @click="play" v-show="!lishow" title="播放"/>
            <img src="@/assets/images/pause.png"  @click="pause" v-show="lishow" title="暂停"/>
            <i class="el-icon-caret-right" title="下一张" @click="next"></i>
                <el-select  @change="changeWxt" v-model="wxtId" style="float: left;width: 194px;line-height: 45px; margin-left: 10%;">
                <el-option
                    v-for="item in wxtOption"
                    :key="item.path"
                    :label="item.name"
                    :value="item.path">
                </el-option>
            </el-select>
        </div>
        <div style="height:100%;padding-top:128px;x">
            <el-row>
                <el-col :span="24">
                    <div  v-for="(item,index) in imgList" :key="index" class="imglist">
                    <!--  <span> {{ item.name }}</span>-->
                        <img  v-bind:src="item.path" style="max-height:850px;"/>
                    </div>
                </el-col>
                <div style="clear:both"></div>
            </el-row>
        </div>
        
    </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "wxyt",
  data() {
    return {
        imgList:[],
        index:0,
        lishow:false,
        timer:null,
        wxtOption:[],
        wxtId:"",
    };
  },
 
  methods: {
    changeWxt(e){
        for(var i=0;i<this.wxtOption.length;i++){
            if(this.wxtOption[i].path==e){
                this.index=i;
                this.changeoptions(i);
                this.lishow=false;
                clearInterval(this.timer); 
                return;
            }
      }
    },
    getList(){
            this.$http.get(window.HTCFG.apiUrl+'api/core/wxyt/basic/',{}).then(function(res){ 
            this.imgList=res.data;//获取数据
            this.wxtOption=res.data;
            for(let i=0;i<this.wxtOption.length;i++){
                this.wxtOption[i].path=this.wxtOption[i].path.replace("http://10.43.15.16/cfrddss-pic", "http://218.77.42.151:8098/wxytload")
            }
            console.log(this.wxtOption)
            this.wxtId=this.wxtOption[this.wxtOption.length-1].name
            this.index=this.wxtOption.length-1;      
            }) 
    },
     // 遍历所有数字导航实现点击切换至对应的图片 
    changeoptions(curindex){  
         for(var j=0;j<$(".imglist").length;j++){  
              $(".imglist").eq(j).hide();  
          } 
          $(".imglist").eq(curindex).show();
          this.index=curindex; 
          this.wxtId=this.wxtOption[this.index].name;
    },
    //点击play 播放
    play(){
        this.lishow=!this.lishow;
        var that=this;
        this.timer=setInterval(autoplay,2000); 
        function autoplay(){
             that.index++; 
            //设置循环
            if(that.index>=that.wxtOption.length-1){
                that.index=0;
            }
            that.changeoptions(that.index); 
        }
         
    },
    //暂停
    pause(){
        this.lishow=!this.lishow;
        clearInterval(this.timer);  
    },
     //前一张
    pre(){
     if(this.index==0){
       this.index=this.wxtOption.length-1;
     }else{
       this.index--;
     }
    //  this.ldtId=this.ldtOption[this.index].value;
     this.changeoptions(this.index);
    },
    next(){
     if(this.index==this.wxtOption.length-1){
       this.index=0;
     }else{
       this.index++
     }
     this.changeoptions(this.index);
    }
  },
  mounted() {
      $(".wxyt").height(window.innerHeight-140-35-20);
      this.getList();
  },
  components: {
  }
};
</script>
<style scoped lang="less">
.wxyt{
    width:100%;
    margin:0 auto;
}
.wxyt div{
    text-align: center
}
.imglist{
    position: absolute;
    top: 0px;
}
.wxtPlay{
    width:100%;
    height:45px;
}
.wxtPlay i{
  font-size: 30px;
  line-height:45px;
  cursor: pointer;
  color: #598cee;
  float:left;
}
.wxtPlay img{
  cursor: pointer;
  float:left;
  margin-top:7px;
  display: inline-block;
}
.wxyt{
  width:100%!important;
}
.wxyt .imglist img{
  width:100%!important;
  display:block;
} 
 
</style>



// WEBPACK FOOTER //
// src/components/mobile/wxyt.vue